export const environment = {
  production: true,
  apiUrl: 'https://api.mermapp.com/api',
  api: '/api',
  hostUrl: 'https://app.mermapp.com/',
  firebaseConfig: {
    apiKey: 'AIzaSyDxlrnP5iPP5ZHjpJpF4HfHljc9go7HMAs',
    authDomain: 'mermapp-production.firebaseapp.com',
    projectId: 'mermapp-production',
    storageBucket: 'mermapp-production.appspot.com',
    messagingSenderId: '241717412079',
    appId: '1:241717412079:web:5a9b609e6be5195f1c5b1a',
    measurementId: 'G-MRPTJWTRYV',
  },
  googleMapKey: 'AIzaSyDEvI_b9iqwj_YzueWIhYf3QJPyxQis5YQ',
  // All the required properties that were missing
  googleApiKey: 'AIzaSyBplgIFwC2CcpQEd48wqbQOp2EMwzgrLnw',
  searchEngineId: 'a7213b2ba19604862',
  openaiApiKey:
    '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',
  mixpanelToken: '05a8bcd630dd63d4c734c08ebe954e1a',
  WONDERPUSH: {
    WEBTOKEN:
      'b85decb02bc28986e35421d7d5914219ae7264b98fdc24b92efda5a36283a6fc',
    ANDROIDID: 'f42efbc8e5aff0edeb87e8275a1945b1af8c6860',
    ANDROIDSERCRET:
      '7813fc38c9069452af570b6de580050d55a67223720fbd2f200a2d4b36f28be9',
    IOSID: 'f42efbc8e5aff0edeb87e8275a1945b1af8c6860',
    IOSSERCRET:
      '7813fc38c9069452af570b6de580050d55a67223720fbd2f200a2d4b36f28be9',
  },
  googlePlayId: '',
  appStoreId: '',
  androidVersionName: '',
  androidVersionCode: '',
  iosVersion: '',
  iosBuildNumber: '',
  // Existing properties
  routers: {},
  payment: {
    stripePublicKey:
      'pk_live_51Lv5YTL1hrltBe0fEcnOndSSHuAqhwxGxOqMF37PgTff3CO1uuxCSlxWKIojQJ8lCrwgbv3tBSz1bBjZ3CCFeyrz00ZU2hKjmc',
    PERLS_MODE: 'payment',
    SUBSCRIPTION_MODE: 'subscription',
    EIGHT_PEARLS: {
      PRODUCT_ID: 'prod_SdP3qFbUYtF82W',
      PRICE_ID: 'price_1Ri8F8L1hrltBe0fK0ikXzLA',
      pearls: 8,
    },
    FORTY_TWO_PEARLS: {
      PRODUCT_ID: 'prod_SdP3M4J5xqiGG2',
      PRICE_ID: 'price_1Ri8FIL1hrltBe0farc7XcaY',
      pearls: 42,
    },
    NINETY_PEARLS: {
      PRODUCT_ID: 'prod_SdP303zTNkUlUT',
      PRICE_ID: 'price_1Ri8FPL1hrltBe0fnd5hJRiB',
      pearls: 90,
    },
    TWO_HUNDREDS_PEARLS: {
      PRODUCT_ID: 'prod_SdP3Y0Q6bSlGOc',
      PRICE_ID: 'price_1Ri8FUL1hrltBe0f7CDeinXP',
      pearls: 200,
    },
    FIVE_HUNDRED_AND_FORTY_PEARLS: {
      PRODUCT_ID: 'prod_SdP33w1xHnu3GZ',
      PRICE_ID: 'price_1Ri8FXL1hrltBe0fKlxidche',
      pearls: 540,
    },
    ONE_THOUSAND_TWO_HUNDRED_PEARLS: {
      PRODUCT_ID: 'prod_SdP36G0hLfRf41',
      PRICE_ID: 'price_1Ri8FaL1hrltBe0f85LUlCdl',
      pearls: 1200,
    },
    ONE_MONTH_SUBSCRIPTION: {
      PRODUCT_ID: 'prod_SdOyX76cVhfyH2',
      PRICE_ID: 'price_1Ri8ALL1hrltBe0fWJ3GJ0bp',
      period: '1 Month',
    },
    THREE_MONTHS_SUBSCRIPTION: {
      PRODUCT_ID: 'prod_SdOyX76cVhfyH2',
      PRICE_ID: 'price_1Ri8ALL1hrltBe0fF1b0JAj2',
      period: '3 Months',
    },
    ONE_YEAR_SUBSCRIPTION: {
      PRODUCT_ID: 'prod_SdOyX76cVhfyH2',
      PRICE_ID: 'price_1Ri8ALL1hrltBe0fHqizcnMo',
      period: '1 Year',
    },
    ONE_MONTH_CHAT_SUBSCRIPTION: {
      PRODUCT_ID: 'prod_SdOrfaYa4sEelA',
      PRICE_ID: 'price_1Ri83KL1hrltBe0foIg40NCF',
      PERIOD: '1 Month',
    },
  },
  discordServerId: '920296167177355284',
  discordServerInviteLink: 'https://discord.com/invite/PM89UWcsgt',
  pipeDreamUrl: 'https://eowmxurvi9ulyx.m.pipedream.net',
  discordServerLink: 'https://discord.com/channels/920296167177355284',
};

